<template>
  <div>
    <b-card
      v-if="!isModal"
      no-body
    >
      <b-card-body>
        <validation-observer ref="validacao">
          <slot name="conteudo" />
        </validation-observer>
      </b-card-body>
      <b-card-footer :style="customFooterStyle">
        <b-row no-gutters>
          <b-col class="text-right">
            <b-btn
              :disabled="desabilitarBotao"
              variant="none"
              class="btn-outline-success"
              style="margin-right:0.25rem"
              @click="salvarCadastro"
            >Salvar</b-btn>
          </b-col>
          <b-btn
            :disabled="desabilitarBotao"
            variant="none"
            class="btn-outline-danger"
            @click="cancelar"
          >Cancelar</b-btn>
        </b-row>
      </b-card-footer>
    </b-card>
    <div v-else>
      <validation-observer ref="validacao">
        <b-form>
          <slot name="conteudo" />
        </b-form>
      </validation-observer>
      <b-row no-gutters>
        <b-col class="text-right">
          <b-btn
            variant="danger"
            style="margin-right:0.25rem"
            @click="cancelar"
          >Cancelar</b-btn>
          <b-btn
            variant="success"
            @click="salvarCadastro"
          >Salvar</b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ValidationObserver, localize } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CadatroBase',
  components: {
    ValidationObserver,
  },
  props: {
    salvar: {
      type: Function,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    cancelarCadastro: {
      type: Function,
      default: function voltar() { this.$router.go(-1) },
    },
    customFooterStyle: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('cadastroBase', ['desabilitarBotao']),
  },
  created() {
    localize('ptBR')
  },
  methods: {
    cancelar() {
      this.cancelarCadastro()
    },
    salvarCadastro() {
      this.$refs.validacao.validate()
        .then(success => {
          if (success) {
            this.chamarSalvarCadastro()
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Preencha os campos corretamente',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    chamarSalvarCadastro() {
      const promisse = this.salvar()
      if (promisse) {
        promisse
          .then((titulo, mensagem) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: titulo,
                text: mensagem,
                icon: 'CheckCircleIcon',
                variant: 'success',
              },
            })
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                // title: 'Não foi possível cadastrar as informações',
                title: err.response.data.message || err.message, // err.message || err.response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
            throw err
          })
      }
    },
  },
}
</script>
